/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('mimic_flatlist_rss_while_uninitialised');
	},
};
